import type { interfaces } from "inversify";
import { computed } from "mobx";
import type CountryResponse from "../entities/countryResponse";
import EnumService from "../services/enumService";
import formatCountryEnumName from "../utils/formatCountryEnumName";

export type CountrySelectMode = "id" | "code";

function onlySepaCountryFilter(country: CountryResponse) {
  return country.isSepaMember;
}

export default class CountrySelectViewModel {
  @computed
  get countrySEPAOptions() {
    if (this.mode === "id") {
      return this.idOptions(true);
    }

    return this.codeOptions(true);
  }

  @computed
  get countryOptions() {
    if (this.mode === "id") {
      return this.idOptions();
    }

    return this.codeOptions();
  }

  constructor(private enumService: EnumService, private mode: CountrySelectMode = "id", private includeDeleted: boolean) {}

  idOptions(onlySepa?: boolean) {
    return this.enumService
      .values("countries")
      .filter(country => (this.includeDeleted ? true : !country.isDeleted))
      .filter(onlySepa ? onlySepaCountryFilter : () => true)
      .sort((a, b) => a.code.localeCompare(b.code))
      .map(country => ({
        id: country.id,
        label: formatCountryEnumName(country),
      }));
  }

  codeOptions(onlySepa?: boolean) {
    return this.enumService
      .values("countries")
      .filter(country => (this.includeDeleted ? true : !country.isDeleted))
      .filter(onlySepa ? onlySepaCountryFilter : () => true)
      .sort((a, b) => a.code.localeCompare(b.code))
      .map(country => ({ id: country.code, label: formatCountryEnumName(country) }));
  }

  static Factory({ container }: interfaces.Context) {
    return (mode?: CountrySelectMode, includeDeleted = false) =>
      new CountrySelectViewModel(container.get(EnumService), mode, includeDeleted);
  }
}
